<app-global-alert-message
  *ngIf="globalAlerts.length && isActiveUserMode"
  [globalAlerts]="globalAlerts"
  [open]="isShowGlobalAlert"
  placement="topLeft"
  (dismiss)="onDismissGlobalAlert($event)"
></app-global-alert-message>

<app-lhcb-migration-modal
  [isOpen]="!!(migrationCompany$ | async) && isActiveUserMode"
  [couponCode]="(migrationCompany$ | async)?.lhcbMigration?.couponCode || null"
  [poaPrice]="poaPrice$ | async"
  [isAcknowledging]="(isAcknowledgingMigration$ | async) || false"
  (discarded)="onMigrationDiscarded()"
  (signThePoa)="onMigrationSignThePoa()"
></app-lhcb-migration-modal>

<app-header *ngIf="isLaptop$ | async"></app-header>
<app-sidebar></app-sidebar>
<app-setting-sidebar></app-setting-sidebar>
<div class="main-container" [ngClass]="{ 'is-desktop': isIsfDesktop || isLCLDesktop, 'is-fixed-height': isIsf && !isHasIsfOcr }">
  <app-content-header></app-content-header>
  <div class="main-container-router">
    <app-user-warnings></app-user-warnings>
    <router-outlet></router-outlet>
  </div>
</div>
